module.exports = __webpack_public_path__ + "media/images/mobile/solutions/explr-bg1-07c8e0c146b19b3c8fcf0b5cf8da7043.png";